<template>
    <section class="page-panel">
        <ui-header v-if="showHeader" :sidebar="false"/>
        <slot name="bradcrumbs" />
        <section class="body" :class="{ 'no-padding':  havePadding == false }">
            <slot name="content" />
        </section>

        <ui-feedback-modal />
        <ui-thank-feedback-modal />
        <ui-active-offer-modal />
        <uiRatingNPS />
    </section>
</template>

<script>
import uiHeader from "@/components/ui/panel-header"
import { uiActiveOfferModal } from '@/components/ui-facilita/active-offer'

import { mapGetters, mapActions } from "vuex"
import { storage } from '@/services/storage'

import uiFeedbackModal from '@/components/ui-facilita/modals/feedback-modal'
import uiThankFeedbackModal from '@/components/ui-facilita/modals/feedback-modal/thank-feedback-modal'
import uiRatingNPS from '@/components/ui-facilita/rating/nps/index.vue'

export default {
    name: 'page-panel-header',

    components: { uiHeader, uiActiveOfferModal, uiRatingNPS, uiFeedbackModal, uiThankFeedbackModal },

    props: {
        havePadding: {
            type: Boolean,
            default: true,
            required: false,
        },
		showHeader: {
			type: Boolean,
            default: true,
            required: false,
		}
    },

    computed: mapGetters("auth", {
        user: "getUser",
    }),

    beforeMount() {
        this.$nextTick(() => {
            const companiesRestricted = this.$store.getters.companiesRestricted
            let user = JSON.parse(storage.get('user_logged'))
            let config = JSON.parse(storage.get('api_config'))

            window.dataLayer[0].user 				 = user
            window.dataLayer[0].configs 			 = JSON.parse(storage.get('get-configs-data'))
            window.dataLayer[0].companies_restricted = companiesRestricted
            window.dataLayer[0].instance_user_id 	 = config.instance + '_' + user.id
            window.dataLayer[0].instance 	 		 = config.instance
        })
    },

    mounted() {
        // Configura os parâmetros do Google Analytics
        // const apiConfig = JSON.parse(storage.get('api_config'))
        // const userLogged = JSON.parse(storage.get('user_logged'))
        // this.$ga.set({
        //     title: apiConfig.instance,
        //     dimension1: userLogged.user_group,
        //     dimension2: userLogged.id.toString(),
        //     dimension3: apiConfig.instance
        // })
    },

    methods: {
        ...mapActions("auth", ["authExists", "validatedToken"]),
    }
}
</script>

<style lang="stylus" scoped>
@import 'styles.styl'
</style>

